// import createLogger from 'vuex/dist/logger'
import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import api from './modules/api'
import endpoint from './modules/endpoint'
import apiGroup from './modules/api-group'
import database from './modules/database'
import crud from './modules/crud'
import token from './modules/token'
import log from './modules/log'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    api,
    endpoint,
    apiGroup,
    database,
    crud,
    token,
    log
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
